// Which result counts when a learner launches again (owner ruling 2026-10-29):
// a course setting on a connection, best (the default), latest or first.
export const RESULT_RULES = [
  { value: 'best', label: 'Best', desc: 'A pass is never replaced by a fail, and the score is the highest the learner has reached.' },
  { value: 'latest', label: 'Latest', desc: "Each launch's result replaces the one before." },
  { value: 'first', label: 'First', desc: "The learner's first final result stays." }
]

export const RESULT_RULE_TITLE = 'Which result counts when a learner launches again'
export const RESULT_RULE_HELP =
  "This decides what we write into the learner's existing record in your LMS: the SCORM attempt we write to, and the grade we post over LTI. If your LMS starts a new attempt for every launch, its own grading method decides across attempts. cmi5: a pass can't become a fail within one registration, so Latest can't turn a cmi5 pass into a fail."
export const RESULT_RULE_UNAVAILABLE = 'Not available yet: this needs a database update.'

export const resultRuleLabel = rule => {
  const found = RESULT_RULES.find(r => r.value === rule)
  return found ? found.label : null
}
